import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getAllTeamMembers = (data, callback) => {
    return fetchDataAndProceed('/users/admins', METHOD_TYPES.GET, data, callback);
};

export const addNewMembers = (data, callback) => {
    return fetchDataAndProceed('/users/admins', METHOD_TYPES.POST, data, callback);
};

export const deleteTeamMember = (data, callback) => {
    return fetchDataAndProceed('/users/admins', METHOD_TYPES.DELETE, data, callback);
};

export const changeMemberActivation = (data, callback) => {
    return fetchDataAndProceed('/users/admins/activation', METHOD_TYPES.PATCH, data, callback);
};

export const getUserPermissions = (data, callback) => {
    return fetchDataAndProceed('/users/admins/settings', METHOD_TYPES.GET, data, callback);
};

export const updateUserPermissions = (data, callback) => {
    return fetchDataAndProceed('/users/admins/settings', METHOD_TYPES.PATCH, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/team_member_setting_details/api.js